import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { GoogleCharts } from 'google-charts';
import { Subscription } from 'rxjs';
import { ChartService } from '../chart/chart.service';
import { DateTimeService } from '../date-time.service';
import { fade } from '../shared/animations';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  animations: [fade]
})
export class ChartComponent implements OnInit, OnDestroy {
  chartSubscription: Subscription;
  data = [];
  columnNames;
  title = 'Last week';
  type = 'Line';
  ready = false;
  chartWrapper;
  options;
  chart;
  chartContainer;
  resizer;
  selectedVal = '1 months';

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    clearTimeout(this.resizer);
    this.resizer = setTimeout(this.resizeEnd.bind(this), 200);
  }
  resizeEnd() {
    if (this.chart && this.chartContainer) {
      this.clear();
      this.drawChart();
    }
  }

  constructor(
    private chartService: ChartService,
    private dtService: DateTimeService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.chartSubscription = this.chartService.chartSubject$
      .subscribe((res: any) => {
        if (res === 'clear') {
          this.clear();
          return;
        }

        this.data = [];
        this.columnNames = ['', ''];
        res.forEach(element => {
          const date = this.dtService.convertFilingDateShort(new Date(element[0] + 'T16:00:00-04:00'));
          const dateTooltip = this.dtService.convertFilingDateNoSecs(new Date(element[0] + 'T16:00:00-04:00'));
          const price = +element[4];
          this.data.push(
            [
              date,
              price,
              this.createCustomHTMLContent(dateTooltip, (price.toFixed(2)).toString())
            ]
          );
        });

        this.clear();
        GoogleCharts.load(this.drawChart.bind(this));
        this.cdr.detectChanges();
      });
  }

  createCustomHTMLContent(date: string, price: string) {
    return '<div style="padding:6px 10px;">' +
      `<span style="color:grey">` + date + `<\span>` + '<br>'
      + `<span style="color:black;font-weight:bold">` + price + `<\span>` + '</div>';
  }

  drawChart() {
    const data = new GoogleCharts.api.visualization.DataTable();
    data.addColumn('string', '');
    data.addColumn('number', '');
    // tslint:disable-next-line: object-literal-key-quotes
    data.addColumn({ 'type': 'string', 'role': 'tooltip', 'p': { 'html': true } });
    data.addRows(
      this.data
    );
    this.options = {
      legend: 'none',
      lineWidth: 1,
      fontSize: 10,
      allowAsync: true,
      tooltip: { isHtml: true },
      crosshair: { orientation: 'both', trigger: 'focus', opacity: 0.5, color: 'green' },
      chartArea: { width: '80%', height: '80%' },
    };
    this.chartContainer = document.getElementById('chart');
    this.chart = new GoogleCharts.api.visualization.LineChart(this.chartContainer);
    GoogleCharts.api.visualization.events.addListener(this.chart, 'ready', () => {
      this.ready = true;
      this.cdr.detectChanges();
    });
    this.chart.draw(data, this.options);
    this.cdr.detectChanges();
  }

  onValChange(val: string) {
    console.log('chart comp val changed:', val);
    this.chartService.getChart(val);
    this.selectedVal = val;
  }

  clear() {
    if (this.chart) {
      this.chart.clearChart();
    }
  }

  ngOnDestroy() {
    this.clear();
    if (this.chartSubscription) {
      this.chartSubscription.unsubscribe();
    }
  }
}
